var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook2 = function SvgFacebook2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 12.166c0 5.966 4.333 10.927 10 11.933v-8.667h-3v-3.333h3V9.432c0-3 1.933-4.666 4.667-4.666.866 0 1.8.133 2.666.266v3.067H16.3c-1.467 0-1.8.733-1.8 1.667v2.333h3.2l-.533 3.333H14.5v8.667c5.667-1.006 10-5.966 10-11.933 0-6.637-5.4-12.067-12-12.067S.5 5.529.5 12.166Z",
    fill: "ivory"
  })));
};
export default SvgFacebook2;